// extracted by mini-css-extract-plugin
module.exports = {"FormBoxSection":"FormBoxSection-module__FormBoxSection___RqEBe","content":"FormBoxSection-module__content___YWdfV","formHeader":"FormBoxSection-module__formHeader___cRATY"};